module.exports = __webpack_public_path__ + "static/media/legal-articles.bea7442a.svg";